import { env } from "../datas.config";
import { socket } from "./socket";

export function sendMessageInbox(message, workspaceId) {
  socket.emit("sendMsgInbox", { canal: message.roomId, workspaceId, ...message });
}

export async function sendMessageFileInbox(object, formData, msgForSocket, workspaceId) {
  let status = "";
  try {
    const res = await fetch(
      `${env.domain}/api/auth/uploads/conversations/conversation/upload-file/${object.roomId}`,
      {
        method: "post",
        body: formData,
        credentials: "include",
      }
    );
    const data = await res.json();
    status = data.sms.status;
    socket.emit("send_message_inbox_file", { ...msgForSocket, workspaceId });
  } catch (erreur) {
    console.clear();
    console.error(erreur);
  } finally {
    return status;
  }
}

export const getFileSize = (file) => {
  const sizeInBytes = file;
  const units = ["Octets", "Ko", "Mo"];
  let size = sizeInBytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  return `${size.toFixed(2)} ${units[unitIndex]}`;
};

export const sendMessageAccessCodeInbox = (datas, workspaceId) => {
  const { receivers, accessCode, user } = datas;
  socket.emit("send_code_meeting_batch", {
    receivers: receivers.map((r) => r.id),
    accessCode,
    emetteur: user.userId,
    emetteurImage: user.userImage,
    workspaceId,
  });
};

export const jeSupprimeLeMessageInbox = (emetteur, destinataire, messageId, workspaceId) => {
  socket.emit("je_supprime_le_message_inbox", {
    messageId,
    emetteur,
    destinataire,
    workspaceId,
  });
};

export function supprimerTousEnInbox(roomId, emetteur, interlocuteur, workspaceId) {
  socket.emit("je_supprime_tous_les_messages_inbox", {
    roomId,
    emetteur,
    interlocuteur,
    workspaceId,
  });
}

export const sendMessageMeeting = (msg, setMessages) => {
  socket.emit("send_message_meeting", msg, (_datas) => {
    const { messages, me } = _datas;
    const { timeUnix } = me;
    const msgs = messages.filter((msg) => msg.timeUnix > timeUnix);
    const myMessages = msgs.sort((a, b) => {
      return b.timeUnix - a.timeUnix;
    });
    setMessages(myMessages);
  });
};
